import { visio } from "assets/images/illustrations";
import Button from "components/atoms/Button/Button";
import { FormattedMessage } from "react-intl";
import Route from "routes/Routes";
import { navigate } from "utils";

export type VideoCallEndedProps = {
  className?: string;
}

const VideoCallEnded = ({ className }: VideoCallEndedProps): JSX.Element => {
  return (
    <div className={`flex flex-col gap-4w justify-center items-center ${className}`}>
      <img className="size-[178px]" alt="visio illustration" src={visio}></img>
      <h2 className="text-header5"><FormattedMessage id="videoCall.call.ended.title" /></h2>
      <p className="text-body1"><FormattedMessage id="videoCall.call.ended.body" values={{ tabletOwner: '' }} /></p>
      <Button onClick={() => navigate(Route.HOME, { hasSelectedChannelParam: false })}>
        <FormattedMessage id="videoCall.call.ended.goToSiteFamille" />
      </Button>
    </div>
  )
}

export default VideoCallEnded;